import {Component, Input, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AppConfigService} from '../../../services/app.config.service';
import {ChangeRequestVO} from '../../../generate/TldChangeResultVO';

@Component({
    selector: 'lib-open-change-requests',
    templateUrl: './open-change-requests.component.html',
    styleUrls: ['./open-change-requests.component.scss'],
    standalone: false
})
export class OpenChangeRequestsComponent implements OnInit {

  @Input()
  openChangeRequests: ChangeRequestVO[];

  constructor(private appConfigService: AppConfigService, private router: Router) {
  }

  ngOnInit(): void {
  }

  navigateToCr(requestId: string) {
    if (this.appConfigService.isTldManagerInterface()) {
      this.router.navigateByUrl('/user/request-details/' + requestId);
    } else {
      this.router.navigateByUrl('/admin/request-details/' + requestId);
    }
  }
}
